export default "__VITE_ASSET__CzezJOMD__"